import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios'; // axios
import * as types from './mutation-types';
import CryptoJS  from 'crypto-js';

import base from './modules/base';
import status from './modules/status';
import member1 from './modules/member';
import other from './modules/other';

Vue.use(Vuex);

function setToken(state, token) {
  state.token = token;
  sessionStorage.setItem('xjz_sys_token', state.token);
  localStorage.setItem('xjz_sys_token', state.token);
}

export default new Vuex.Store({
  //strict: process.env.NODE_ENV !== 'production', // 开发模式下启用严格模式
  state: {
    firstLogin: true,
    logged: false,
    token: '',
    c_token: '',
    mtoken: '',
    settingvue: {
      hashcode: ''
    },
    userinfo: {
      id: '',
      type: null,
      empid: '',
      username: '',
      password: '',
      captcha: '',
      name: '',
      mobile: '',
      sex: true,
      rolename: '',
      issuper: false,
      permissions: [],
      menuList: [],
      roleList: []
    },
    backUrl: null, // 登录成功后返回的url
    member: {
      id: '',
      nickname: '',
      name: '',
      sfzh: '',
      headpic: '',
      mobile: '',
      openid: '',
      code: '',
      address: {}
    },
    settings: {
      title: '',
      cardbg: ''
    },
    reloadFlag: false,
    isSm: false, // 响应式尺寸(sm)
  },
  modules: {
    base: base,
    status: status,
    member1: member1,
    other: other
  },
  mutations: {
    clearStorage(state, args) {
      sessionStorage.removeItem('xjz_sys_firstLogin');
      sessionStorage.removeItem('xjz_sys_logged');
      sessionStorage.removeItem('xjz_sys_userinfo');
      sessionStorage.removeItem('xjz_sys_token');

      localStorage.removeItem('xjz_sys_firstLogin');
      localStorage.removeItem('xjz_sys_logged');
      localStorage.removeItem('xjz_sys_userinfo');
      localStorage.removeItem('xjz_sys_starttime');
      localStorage.removeItem('xjz_sys_token');
    },
    [types.JY_SETTINGVUE_SET] (state, args) {
      if (args.settingvue) {
        state.settingvue = args.settingvue;
        localStorage.setItem('xjz_sys_settingvue', JSON.stringify(args.settingvue));

        if (args.callback) {
          args.callback();
        }
      }
    },
    [types.JY_TOKEN_GET] (state, args) {
      // setToken(state, args.token);
      //console.log('token-'+ state.token)
      state.c_token = args.token;
    },
    [types.JY_LOAD_PERMISSIONS] (state, args) {
      if (args.json && args.json[types.KEY_STATUS] === types.CODE_SUCCESS) {
        state.userinfo.permissions = args.json.obj.permissions;
        state.userinfo.roleList = args.json.obj.roleList;
        state.userinfo.unitList = args.json.obj.unitList;
        state.userinfo.allUnitList = args.json.obj.allUnitList;
        state.userinfo.allEmpList = args.json.obj.allEmpList;
        state.userinfo.unit = args.json.obj.unit;
        state.userinfo.company = args.json.obj.company;
        // 更新sessionStorage
        // sessionStorage.setItem('xjz_sys_userinfo', JSON.stringify(state.userinfo));
        // localStorage.setItem('xjz_sys_userinfo', JSON.stringify(state.userinfo));
      } else {
        args.callback && (args.callback.call(this, false, args.json[types.KEY_MESSAGE] || '获取权限失败', args.json[types.KEY_OBJ]));
      }
    },
    [types.JY_BACKURL] (state, args) {
      state.backUrl = args.backUrl || '';
      sessionStorage.setItem('xjz_web_backUrl', args.backUrl);
      console.log('state.backUrl---'+ state.backUrl)
    },
    [types.JY_BACKURL_CLEAR] (state) {
      state.backUrl = '';
      sessionStorage.removeItem('xjz_web_backUrl');
      console.log('state.backUrl--remove---'+ state.backUrl)
    },
    // 个人用户
    [types.JY_LOGIN_MEMBER] (state, args) {
      if (args.json && args.json[types.KEY_STATUS] === types.CODE_SUCCESS) {
        state.member.id = args.json.obj.id;
        state.member.nickname = args.json.obj.nickname;
        state.member.name = args.json.obj.name;
        state.member.sfzh = args.json.obj.sfzh;
        state.member.headpic = args.json.obj.headpic;
        state.member.mobile = args.json.obj.mobile;
        state.member.openid = args.json.obj.openid_gzh;
        state.member.code = args.json.obj.code;

        let _address = args.json.obj._address;
        state.member.address = _address ? JSON.parse(_address) : {};

        sessionStorage.setItem('xjz_web_member', JSON.stringify(state.member));

        state.mtoken = args.json.obj.token;
        sessionStorage.setItem('xjz_web_mtoken', state.mtoken);
        localStorage.setItem('xjz_web_mtoken', state.mtoken);

        // callback
        args.callback && (args.callback.call(this, true, '', args.json));
      } else {
        // callback
        args.callback && (args.callback.call(this, false, args.json[types.KEY_MESSAGE] || '登录失败', args.json[types.KEY_OBJ]));
      }
    },
    // 更新会员地址
    [types.MEMBER_ADDRESS] (state, address) {
      let member = state.member;
      if (!member || !member.id) {
        let _member = sessionStorage.getItem('xjz_web_member');
        if (_member) {
          member = JSON.parse(_member);
        }
      }
      if (member) {
        member.address = address;
        state.member = member;
        sessionStorage.setItem('xjz_web_member', JSON.stringify(member));
      }
    },
    [types.JY_LOGIN] (state, args) {
      //console.log(args.json)
      if (args.json && args.json[types.KEY_STATUS] === types.CODE_SUCCESS) {
        state.firstLogin = false;
        state.logged = true;

        state.userinfo.id = args.json.obj.id;
        state.userinfo.type = args.json.obj.type;
        state.userinfo.empid = args.json.obj.empid;
        state.userinfo.username = args.json.obj.username;
        state.userinfo.name = args.json.obj.name;
        state.userinfo.mobile = args.json.obj.mobile;
        state.userinfo.issys = args.json.obj.issys;
        state.userinfo.issuper = args.json.obj.issuper;
        state.userinfo.password = ''; // 不存密码
        state.userinfo.captcha = ''; // 不存验证码
        state.userinfo.permissions = args.json.obj.permissions;
        state.userinfo.menuList = args.json.obj.menuList;
        state.userinfo.roleList = args.json.obj.roleList;

        // 更新token
        if (args.json.obj.token) {
          setToken(state, args.json.obj.token);
        }
        localStorage.setItem('xjz_sys_starttime', new Date().getTime()); // 开始时间
        // callback
        args.callback && (args.callback.call(this, state.logged, '', args.json));

      } else {
        // callback
        args.callback && (args.callback.call(this, false, args.json[types.KEY_MESSAGE] || '登录失败', args.json[types.KEY_OBJ]));
      }

      //console.log(sessionStorage.getItem('userinfo').username)
    },
    [types.JY_LOGOUT] (state, flag) {
      state.firstLogin = true;
      state.logged = false;
      state.userinfo.id = '';
      state.userinfo.type = null;
      state.userinfo.empid = '';
      state.userinfo.username = '';
      state.userinfo.password = '';
      state.userinfo.captcha = '';
      state.userinfo.name = '';
      state.userinfo.mobile = '';
      state.userinfo.issuper = false;
      //state.userinfo.sex = true;
      state.userinfo.rolename = '';
      //sessionStorage.removeItem('token');
      this.commit('clearStorage');

      // reload flag fixed keep-alive
      state.reloadFlag = flag ? true : false;
    },
    setSetting(state, setting) {
      state.settings.title = setting.site_title;
      state.settings.cardbg = setting.cardbg;
      sessionStorage.setItem('xjz_web_setting', JSON.stringify(state.settings));
    }
  },
  getters: {
    userinfo: (state, getters) => {
      return state.userinfo;
    },
    token: (state) => {
      let token = state.token;
      if (!token) {
        token = sessionStorage.getItem('xjz_sys_token') || localStorage.getItem('xjz_sys_token');
      }
      return token || '';
    },
    mtoken: (state) => {
      let token = state.mtoken;
      if (!token) {
        token = sessionStorage.getItem('xjz_web_mtoken') || localStorage.getItem('xjz_web_mtoken');
      }
      return token || '';
    },
    member: (state) => {
      let member = state.member;
      if (!member || !member.id) {
        let _member = sessionStorage.getItem('xjz_web_member');
        if (_member) {
          member = JSON.parse(_member);
        }
      }

      return member || state.member;
    },
    backUrl: (state, getters) => {
      let backUrl = state.backUrl;
      if (!backUrl) {
        backUrl = sessionStorage.getItem('xjz_web_backUrl');
      }
      if (backUrl == 'null') {
        backUrl = '';
      }

      return backUrl || '';
    },
    settingvue: (state, getters) => {
      let settingvue = state.settingvue;
      if (!settingvue || !settingvue.hashcode) {
        settingvue = localStorage.getItem('xjz_sys_settingvue');
        if (settingvue) {
          settingvue = JSON.parse(settingvue);
          state.settingvue = settingvue;
        }
      }
      if (!settingvue) {
        settingvue = state.settingvue;
      }
      return settingvue;
    },
    settings: (state) => {
      let setting = state.settings;
      if (!setting || !setting.title) {
        setting = sessionStorage.getItem('xjz_web_setting');
        if (setting) {
          setting = JSON.parse(setting);
          state.settings = setting;
        }
      }
      if (!setting) {
        setting = state.settings;
      }
      return setting;
    }
  },
  actions: {
    // 更新settingvue
    [types.JY_SETTINGVUE_SET]({ commit, state }, params) {
      Vue.prototype.$notify.warning({
        title: '系统提示',
        message: '系统有更新，需要重新加载模块，请保存工作后，点击此处刷新浏览器！',
        duration: 0,
        showClose: false,
        onClick: (notify) => {
          // 更新setting，刷新页面
          commit(types.JY_SETTINGVUE_SET, {
            settingvue: params.settingvue,
            callback: () => {
              params.callback
                ? (params.callback)()
                : window.location.reload(true);
            }
          });
        }
      });
    },
    // 检查登录
    [types.JY_LOGIN_CHECK] ({commit, state}, callback) {
      let token = sessionStorage.getItem('xjz_sys_token') || localStorage.getItem('xjz_sys_token');
      let starttime = localStorage.getItem('xjz_sys_starttime');

      // 判断是否过期[6月]
      // (starttime + 3600000 * 24 * 180) > new Date().getTime()
      if (starttime && (parseInt(starttime) + (3600000 * 24 * 180)) < new Date().getTime()) {
        token = null;
        commit('clearStorage');
      } else {
        // 更新过期时间
        localStorage.setItem('xjz_sys_starttime', new Date().getTime()); // 开始时间
      }
      // 需要登录
      if (!state.token && !token) {
        callback(false);
        return;
      }
      // 如果state.token为空
      if (!state.token) {
        state.token = token;
      }

      if (state.userinfo && state.userinfo.id && state.token) {
        // console.log('has userinfo!')
        callback(true);
      } else {
        // console.log('token login!')
        // token 登录
        this.dispatch(types.JY_LOGIN_TOKEN, { newtoken: token, callback: callback });
      }
    },
    // 获取token
    [types.JY_TOKEN_GET]({ commit, state }, callback) {
      axios.post('sys/login/getToken', {}, {withCredentials:true})
        .then((response) => {
          commit(types.JY_TOKEN_GET, {token: response.data});
          callback && (callback(response.data));
        })
        .catch((response) => {
          // callback && (callback.call(this, response.data || '服务器错误！'));
        });
    },
    [types.JY_LOAD_PERMISSIONS]({ commit, state }, callback) {
      axios.get('sys/login/getPermiss', {headers: {Authorization: state.token}})
        .then((response) => {
          commit(types.JY_LOAD_PERMISSIONS, {json: response.data, callback: callback});
        })
        .catch((response) => {
          callback && (callback.call(this, response.data || '服务器错误！'));
        });
    },
    [types.JY_LOGIN]({ commit, state }, callback) {
      // Encrypt
      let key = CryptoJS.enc.Latin1.parse(state.c_token.substr(0, 16));
      let iv = CryptoJS.enc.Latin1.parse('0102030405060708');
      let password = CryptoJS.AES.encrypt(state.userinfo.password, key, {iv:iv, mode:CryptoJS.mode.CBC, padding:CryptoJS.pad.Pkcs7 });
      let options = {username: state.userinfo.username, password: password.toString(), captcha: state.userinfo.captcha};
      axios.post('sys/login/login2', options, {headers: {Authorization: state.token}, withCredentials:true})
        .then((response) => {
          // 响应成功回调
          commit(types.JY_LOGIN, {json: response.data, callback: callback});
        })
        .catch((response) => {
          // 响应错误回调
          callback && (callback.call(this, false, response.data || '服务器错误！'));
        });
    },
    [types.JY_LOGIN_TOKEN]({ commit, state }, obj) {
      axios.post('sys/login/login4token', {}, {headers: {Authorization: obj.newtoken}, withCredentials:true})
        .then((response) => {
          // 响应成功回调
          commit(types.JY_LOGIN, {json: response.data, callback: obj.callback});
        })
        .catch((response) => {
          // 响应错误回调
          obj.callback && (obj.callback.call(this, false, response.data || '服务器错误！'));
        });
    },
    [types.JY_LOGOUT]({ commit, state }, flag) {
      axios.post('sys/logout2', {}, {headers: {Authorization: state.token}, withCredentials:true})
        .then((response) => {
          commit(types.JY_LOGOUT, flag);
          window.location.reload();
          // 响应成功回调
          console.log('logout success!')
        })
        .catch((response) => {
          console.log('logout error!')
        });
    },
    // 个人会员登录for token
    [types.JY_LOGIN_MEMBER]({ commit, state }, obj) {
      axios.post('vue/login/login4token', {}, {headers: {Authorization: obj.newtoken}, withCredentials:true})
      .then((response) => {
          state.mtoken = obj.newtoken;
          // 响应成功回调
          commit(types.JY_LOGIN_MEMBER, {json: response.data, callback: obj.callback});
        })
        .catch((response) => {
          // 响应错误回调
          obj.callback && (obj.callback.call(this, false, response.data || '服务器错误！'));
        });
    },
    
  }
})
